import {useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import type {ButtonHTMLAttributes} from 'react'
import {twMerge} from 'tailwind-merge'
import env from '../../../constants/env'
import SwapIcon from '../../../assets/images/swap.svg'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    className?: string
}

function VgenSwitchButton({className, disabled, ...props}: Props) {
    const {t} = useTranslation('dashboard')
    const {workspaceId} = useParams()

    const handleClick = () => {
        if (!workspaceId) return

        const url = `${env.VGEN_APP_BASE_URL}/workspace/${workspaceId}`
        window.location.href = url
    }

    return (
        <button
            type="button"
            disabled={disabled}
            onClick={handleClick}
            className={twMerge(
                'w-48 h-11 px-3.5 rounded',
                'inline-flex items-center justify-between',
                'transition-colors transition-shadow',
                'cursor-pointer',

                'bg-gray-50 text-purple-700 outline outline-1 outline-purple-700',
                'hover:bg-purple-200 hover:shadow-[0px_2px_8px_0px_rgba(0,0,0,0.15)]',

                'disabled:opacity-20 disabled:cursor-not-allowed',
                'disabled:hover:bg-white disabled:hover:shadow-none',

                className,
            )}
            {...props}
        >
            <span className="text-lg font-medium">
                {t('V-GEN 전환')}
            </span>
            <img src={SwapIcon} alt="vgen-switch" className="h-5 w-5"/>
        </button>
    )
}

export default VgenSwitchButton
